import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * 기기 단위 푸시 상태(AC0-260, localStorage — 계정이 바뀌어도 기기에 남는다).
 * asked = F01-15 소프트 애스크를 한 번 보여 줌(두 버튼 어느 쪽이든) · off = 설정에서 알림을 끔 · token = 서버에 등록한 FCM 토큰(로그아웃 본문에 실어 서버가 지운다)
 */
type PushState = {
  asked: boolean;
  off: boolean;
  token: string | null;
  markAsked: () => void;
  setOff: (off: boolean) => void;
  setToken: (token: string | null) => void;
};

export const usePushStore = create<PushState>()(
  persist(
    (set) => ({
      asked: false,
      off: false,
      token: null,
      markAsked: () => set({ asked: true }),
      setOff: (off) => set({ off }),
      setToken: (token) => set({ token }),
    }),
    { name: "hamlak.push", partialize: (s) => ({ asked: s.asked, off: s.off, token: s.token }) },
  ),
);
